module.exports = __webpack_public_path__ + "static/media/United_transparant_blue.34d16313.png";